import { useEffect, useState } from 'react';
import { autorun } from 'mobx';
import CreatePortfolioModalStore from 'store/modules/proposal/ui/createPortfolioModalStore';
import RFQProposalPageStore from 'store/pages/rfq/rfq-response/proposal-rfq/pageStore';
import { useRFQProductLineDelegate } from 'store/pages/rfq/rfq-response/proposal-rfq/rfqProductLineContext';
import { useRootStore } from 'store/rootStore';

export default function useCreatePortfolioModalStore(): CreatePortfolioModalStore<RFQProposalPageStore> {
  const { rfqProposalPageStore } = useRootStore();
  const productLineDelegate = useRFQProductLineDelegate();

  const [store, setStore] = useState(
    () => new CreatePortfolioModalStore({ pageStore: rfqProposalPageStore, productLineDelegate }),
  );

  useEffect(() => {
    const disposer = autorun(() => {
      setStore(new CreatePortfolioModalStore({ pageStore: rfqProposalPageStore, productLineDelegate }));
    });

    return (): void => disposer();
  }, [productLineDelegate, rfqProposalPageStore]);

  return store;
}
